
import React, { useState, useEffect } from "react";
import { getAllAllowance } from "../../api/allowanceApi";
import { getAllDeduction } from "../../api/deductionApi";
import { getSalarySlipForEmployee } from "../../api/salaryApi";

export default function SalarySlipForEmployee() {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [salarySlip, setSalarySlip] = useState(null);
  const [error, setError] = useState("");
  const [allowancesMaster, setAllowancesMaster] = useState([]);
  const [deductionsMaster, setDeductionsMaster] = useState([]);
  const employeeCode = sessionStorage.getItem("username"); // from login

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        setAllowancesMaster(await getAllAllowance());
        setDeductionsMaster(await getAllDeduction());
      } catch (err) {
        console.error("Master fetch error:", err);
      }
    };
    fetchMasterData();
  }, []);

  const handleShowSlip = async () => {
    setError("");
    setSalarySlip(null);

    if (!month || !year) {
      setError("Please enter both month and year.");
      return;
    }

    try {
      const slip = await getSalarySlipForEmployee(employeeCode, month, year);
      if (slip?.data) setSalarySlip(slip.data);
      else setError("No salary slip found for this period.");
    } catch (err) {
      console.error(err);
      setError("Failed to fetch salary slip.");
    }
  };

  const convertNumberToWords = (num) => {
    const a = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
    const b = ["","", "Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
    if ((num = num.toString()).length > 9) return "Overflow";
    const n = ("000000000" + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return;
    let str = "";
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + " Crore " : "";
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + " Lakh " : "";
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + " Thousand " : "";
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + " Hundred " : "";
    str += (n[5] != 0) ? ((str != "") ? "and " : "") + (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) + " Only" : "";
    return str;
  };
/**
  const handlePrintSingle = (row) => {
    let printHTML = `<html><head><title>Salary Slip</title><style>
      body { font-family: Arial; font-size:12px; }
      .header { text-align:center; font-weight:bold; margin-bottom:10px; }
      table { width:100%; border-collapse:collapse; margin-bottom:10px; }
      th, td { border:1px solid #000; padding:4px; }
    </style></head><body>`;

    printHTML += `<div class="header">Salary Slip for ${row.employeeName} (${row.employeeCode})</div>`;

    printHTML += `<table>
      <tbody>
        <tr><td><strong>Employee Name</strong></td><td>${row.employeeName}</td></tr>
        <tr><td><strong>Employee Code</strong></td><td>${row.employeeCode}</td></tr>
        <tr><td><strong>UAN No.</strong></td><td>${row.uanNo}</td></tr>
        <tr><td><strong>Bank A/C</strong></td><td>${row.bankAccountNo}</td></tr>
        <tr><td><strong>Department</strong></td><td>${row.departmentName}</td></tr>
        <tr><td><strong>Section</strong></td><td>${row.sectionName}</td></tr>
        <tr><td><strong>Total Days</strong></td><td>${row.totalWorkingDays}</td></tr>
        <tr><td><strong>Present Days</strong></td><td>${row.noOfPresentDays}</td></tr>
      </tbody>
    </table>`;

    printHTML += `<h5>Earnings</h5><table><tbody>`;
    allowancesMaster.forEach((a, i) => {
      printHTML += `<tr><td>${a.allowanceName}</td><td>${row[`allowance${i+1}`] || 0}</td></tr>`;
    });
    printHTML += `<tr><td><strong>Total Earnings</strong></td><td>${row.totalAllowance}</td></tr>`;
    printHTML += `</tbody></table>`;

    printHTML += `<h5>Deductions</h5><table><tbody>`;
    deductionsMaster.forEach((d, i) => {
      printHTML += `<tr><td>${d.deductionName}</td><td>${row[`deduction${i+1}`] || 0}</td></tr>`;
    });
    printHTML += `<tr><td><strong>Total Deductions</strong></td><td>${row.totalDeduction}</td></tr>`;
    printHTML += `</tbody></table>`;

    printHTML += `<div style="text-align:right;font-weight:bold;">
      Net Salary: ₹${Math.round(row.netSalary)}<br/>
      (${convertNumberToWords(Math.round(row.netSalary))})
    </div>`;

    printHTML += `</body></html>`;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(printHTML);
    printWindow.document.close();
    printWindow.print();
  };
 */
  // Map allowances and deductions for display
  const mappedAllowances = allowancesMaster.map((a, i) => ({ name: a.allowanceName, value: salarySlip ? salarySlip[`allowance${i+1}`] || 0 : 0 }));
  const mappedDeductions = deductionsMaster.map((d, i) => ({ name: d.deductionName, value: salarySlip ? salarySlip[`deduction${i+1}`] || 0 : 0 }));

  return (
    <div className="container mt-4">
      <h5>My Payslip</h5>

      {/* Input Fields */}
      <div className="row mb-3">
        <div className="col-md-3">
          <label>Month (1-12)</label>
          <input type="number" className="form-control" value={month} onChange={(e) => setMonth(e.target.value)} />
        </div>
        <div className="col-md-3">
          <label>Year(YYYY)</label>
          <input type="number" className="form-control" value={year} onChange={(e) => setYear(e.target.value)} />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button className="btn btn-primary btn-sm" onClick={handleShowSlip}>Show Slip</button>
        </div>
      </div>

      {error && <p className="text-danger">{error}</p>}

      {/* Salary Slip shown below the button */}
      {salarySlip && (
        <div className="card mb-3 p-2">
          <h5 className="fw-bold">Employee Name: {salarySlip.employeeName} ({salarySlip.employeeCode})</h5>
          <div className="row">
            {/* Left info */}
            <div className="col-md-6">
              <p className="mb-1"><strong>Bank Account No.:</strong> {salarySlip.bankAccountNo || "-"}</p>
              <p className="mb-1"><strong>Total Days:</strong> {salarySlip.totalWorkingDays}</p>
              <p className="mb-2"><strong>Gross Salary:</strong> ₹{salarySlip.grossSalary}</p>
            </div>

            {/* Right info */}
            <div className="col-md-6">
              <p className="mb-1"><strong>PF/UAN No.:</strong> {salarySlip.uanNo || "-"}</p>
              <p className="mb-2"><strong>Present Days:</strong> {salarySlip.noOfPresentDays}</p>
            </div>
          </div>

          {/* New row: aligned tables */}
          <div className="row mt-2">
            <div className="col-md-6">
              <h6>EARNINGS</h6>
              <table className="table table-sm table-bordered">
                <tbody>
                  {mappedAllowances.map((a, i) => (
                    <tr key={i}><td>{a.name}</td><td className="text-end">{a.value}</td></tr>
                  ))}
                  <tr className="fw-bold"><td>Total Earnings</td><td className="text-end">{salarySlip.totalAllowance}</td></tr>
                </tbody>
              </table>
            </div>
                
            <div className="col-md-6">
              <h6>DEDUCTIONS</h6>
              <table className="table table-sm table-bordered">
                <tbody>
                  {mappedDeductions.map((d, i) => (
                    <tr key={i}><td>{d.name}</td><td className="text-end">{d.value}</td></tr>
                  ))}
                  <tr className="fw-bold"><td>Total Deductions</td><td className="text-end">{salarySlip.totalDeduction}</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="text-end fw-bold">
            Net Salary: ₹{Math.round(salarySlip.netSalary)}<br/>
            <small>({convertNumberToWords(Math.round(salarySlip.netSalary))})</small>
          </div>
          {/* <div className="text-end mt-2">
            <button className="btn btn-outline-primary btn-sm" onClick={() => handlePrintSingle(salarySlip)}>Print Slip</button>
          </div> */}
        </div>
      )}
    </div>
  );
}




// import React, { useState, useEffect } from "react";
// import { getAllAllowance } from "../../api/allowanceApi";
// import { getAllDeduction } from "../../api/deductionApi";
// import { getSalarySlipForEmployee } from "../../api/salaryApi"; // API call: /slip/{employeeCode}/{month}/{year}

// export default function SalarySlipForEmployee() {
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");
//   const [salarySlip, setSalarySlip] = useState(null);
//   const [error, setError] = useState("");

//   const [allowancesMaster, setAllowancesMaster] = useState([]);
//   const [deductionsMaster, setDeductionsMaster] = useState([]);

//   const employeeCode = sessionStorage.getItem("username"); // stored at login

//   useEffect(() => {
//     const fetchMasterData = async () => {
//       try {
//         setAllowancesMaster(await getAllAllowance());
//         setDeductionsMaster(await getAllDeduction());
//       } catch (err) {
//         console.error("Master fetch error:", err);
//       }
//     };
//     fetchMasterData();
//   }, []);

//   const handleShowSlip = async () => {
//     setError("");
//     setSalarySlip(null);

//     if (!month || !year) {
//       setError("Please enter both month and year.");
//       return;
//     }

//     try {
//       const slip = await getSalarySlipForEmployee(employeeCode, month, year);
//       if (slip?.data) {
//         setSalarySlip(slip.data);
//       } else {
//         setError("No salary slip found for this period.");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Failed to fetch salary slip.");
//     }
//   };

//   const convertNumberToWords = (num) => {
//     const a = [
//       "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
//       "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];
//     const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
//     if ((num = num.toString()).length > 9) return "Overflow";
//     const n = ("000000000" + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
//     if (!n) return; let str = "";
//     str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + " Crore " : "";
//     str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + " Lakh " : "";
//     str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + " Thousand " : "";
//     str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + " Hundred " : "";
//     str += (n[5] != 0) ? ((str != "") ? "and " : "") + (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) + " Only" : "";
//     return str;
//   };

//   return (
//     <div className="container mt-4">
//       <h3>Employee Salary Slip</h3>

//       <div className="row mb-3">
//         <div className="col-md-3">
//           <label>Month (1-12)</label>
//           <input
//             type="number"
//             className="form-control"
//             value={month}
//             onChange={(e) => setMonth(e.target.value)}
//           />
//         </div>
//         <div className="col-md-3">
//           <label>Year (e.g. 2025)</label>
//           <input
//             type="number"
//             className="form-control"
//             value={year}
//             onChange={(e) => setYear(e.target.value)}
//           />
//         </div>
//         <div className="col-md-3 d-flex align-items-end">
//           <button className="btn btn-primary w-100" onClick={handleShowSlip}>
//             Show Slip
//           </button>
//         </div>
//       </div>

//       {error && <p className="text-danger">{error}</p>}

//       {salarySlip && (
//         <div className="card p-3 mt-3">
//           <h5>{salarySlip.employeeName} ({salarySlip.employeeCode})</h5>
//           <p><strong>Total Days:</strong> {salarySlip.totalWorkingDays}</p>
//           <p><strong>Present Days:</strong> {salarySlip.noOfPresentDays}</p>

//           <h6>Earnings</h6>
//           <table className="table table-sm table-bordered">
//             <tbody>
//               {allowancesMaster.map((a, i) => (
//                 <tr key={i}>
//                   <td>{a.allowanceName}</td>
//                   <td className="text-end">{salarySlip[`allowance${i + 1}`] || 0}</td>
//                 </tr>
//               ))}
//               <tr className="fw-bold">
//                 <td>Total Earnings</td>
//                 <td className="text-end">{salarySlip.totalAllowance}</td>
//               </tr>
//             </tbody>
//           </table>

//           <h6>Deductions</h6>
//           <table className="table table-sm table-bordered">
//             <tbody>
//               {deductionsMaster.map((d, i) => (
//                 <tr key={i}>
//                   <td>{d.deductionName}</td>
//                   <td className="text-end">{salarySlip[`deduction${i + 1}`] || 0}</td>
//                 </tr>
//               ))}
//               <tr className="fw-bold">
//                 <td>Total Deductions</td>
//                 <td className="text-end">{salarySlip.totalDeduction}</td>
//               </tr>
//             </tbody>
//           </table>

//           <div className="text-end fw-bold mt-3">
//             Net Salary: ₹{Math.round(salarySlip.netSalary)}  
//             <br />
//             <small>({convertNumberToWords(Math.round(salarySlip.netSalary))})</small>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




